import { Component, Input } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { Notification } from '@base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-sms-history-item',
    templateUrl: './sms-history-item.component.html',
    styleUrls: ['./sms-history-item.component.scss']
})
export class SmsHistoryItemComponent extends BaseComponent<BaseState> {
    @Input() Entity: Notification;

    constructor(A: ServiceBagService) {
        super(A, 'SmsHistoryItemComponent', BaseState);
    }
}
